import { connect } from 'react-redux';
import RealTimeDashboards from './RealTimeDashboards';
import { STATE_ROOT } from '../../../../../redux';

const mapStateToProps = state => ({
  app: state[STATE_ROOT].apps.details.settings.settings,
});

export default connect(mapStateToProps, null)(RealTimeDashboards);
